export function generatePassword() {
  // Function creates a 12 digit password with 7 lower case characters,
  // 2 upper case characters, 2 numbers, and 1 special character.
  const lowerset = 'abcdefghijklmnopqrstuvwxyz'
  const upperset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const numberset = '0123456789'
  const specialset = '!@#$%^&*'
  let password = ''

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < 7; i++) {
    password += lowerset.charAt(Math.floor(Math.random() * lowerset.length))
  }
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < 2; i++) {
    password += upperset.charAt(Math.floor(Math.random() * upperset.length))
  }
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < 2; i++) {
    password += numberset.charAt(Math.floor(Math.random() * numberset.length))
  }
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < 1; i++) {
    password += specialset.charAt(Math.floor(Math.random() * specialset.length))
  }

  return password
}
